var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B7B12345-8E9D-4180-8A2B-FB270D207F93") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_In-a-Call-D1-faded",
    transform: "translate(-631.000000, -832.000000)",
    fill: "#929AA6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar",
    transform: "translate(0.000000, 803.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "functions",
    transform: "translate(551.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone",
    transform: "translate(71.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4871194,15.7931304 C25.0941584,15.7931304 25.5862607,16.2852327 25.5862607,16.8922717 C25.5862607,21.3761372 22.230141,25.0761391 17.892883,25.6172958 L17.8922717,27.8836846 C17.8922717,28.4907235 17.4001693,28.9828259 16.7931304,28.9828259 C16.1860914,28.9828259 15.6939891,28.4907235 15.6939891,27.8836846 L15.6933778,25.6172958 C11.3561197,25.0761391 8,21.3761372 8,16.8922717 C8,16.2852327 8.49210232,15.7931304 9.0991413,15.7931304 C9.70618027,15.7931304 10.1982826,16.2852327 10.1982826,16.8922717 C10.1982826,20.5345055 13.1508965,23.4871194 16.7931304,23.4871194 C20.4353642,23.4871194 23.3879781,20.5345055 23.3879781,16.8922717 C23.3879781,16.2852327 23.8800805,15.7931304 24.4871194,15.7931304 Z M16.7931304,6 C19.8283252,6 22.2888368,8.4605116 22.2888368,11.4957065 L22.2888368,15.8922717 C22.2888368,18.9274665 19.8283252,21.3879781 16.7931304,21.3879781 C13.7579355,21.3879781 11.2974239,18.9274665 11.2974239,15.8922717 L11.2974239,11.4957065 C11.2974239,8.4605116 13.7579355,6 16.7931304,6 Z M16.7931304,8.19828259 C14.9720135,8.19828259 13.4957065,9.67458955 13.4957065,11.4957065 L13.4957065,15.8922717 C13.4957065,17.7133885 14.9720135,19.1896956 16.7931304,19.1896956 C18.6142472,19.1896956 20.0905543,17.7133885 20.0905543,15.8922717 L20.0905543,11.4957065 C20.0905543,9.67458955 18.6142472,8.19828259 16.7931304,8.19828259 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon-microphone.b561d6447b0b3db52824b9e8417a592e.svg";
export { ForwardRef as ReactComponent };